import React from "react";
import { History } from "history";
import {
  Box,
  Botao,
  CampoEstatico,
  Alerta,
  TipoAlerta,
  Modal,
  CampoTexto,
  PosicaoTituloCampoTexto,
  Form,
} from "@intechprev/componentes-web";

import { FuncionarioService, EmprestimoService } from "../../../services";
import { MasterPage } from "../..";
import { NumFuncionalidade } from "../../MasterPage";
import { FuncionarioDados, ParametrosContrato, ContratoDisponivel } from "../../../entidades";

import { IParametrosSimulacao } from ".";
import { ArquivoUpload } from "./ArquivoUpload";
import { reCAPTCHA } from "../../../helpers";
import Avaliacao from "../../../components/Avaliacao";
import { DMN_PLANO } from "../../../domains";

interface IProps {
  history?: History;
}

interface IState {
  funcionario: FuncionarioDados;
  oidArquivoUpload: string;
  oidArquivoCartaoMongeral: string;

  valorMargemConsignavel: number;
  contrato: ContratoDisponivel;
  token: string;
  tokenDigitado: string;
  mostrarModalToken: boolean;
  enviarPorSMS: boolean;
  enviarPorEmail: boolean;
  tokenEnviado: boolean;
  ativo: boolean;
  cdPlano: string;

  aderiuContratoEmpréstimoOnline: boolean;
  modalAvaliacao: boolean;
  mostrarCartaoMontreal: boolean;
}

export class SimuladorEmprestimoContratacao extends React.Component<IProps, IState> {
  private recaptcha = new reCAPTCHA("emprestimo_simulador_contratacao");

  private page = React.createRef<MasterPage>();

  private fileUpload: any;

  state: IState = {
    funcionario: null,
    oidArquivoUpload: "",
    oidArquivoCartaoMongeral: "",

    valorMargemConsignavel: 0,
    contrato: null,
    token: "",
    tokenDigitado: "",
    mostrarModalToken: false,
    enviarPorSMS: false,
    enviarPorEmail: false,
    tokenEnviado: false,
    ativo: false,
    cdPlano: "",

    aderiuContratoEmpréstimoOnline: false,
    modalAvaliacao: false,
    mostrarCartaoMontreal: false,
  };

  componentDidMount = async () => {
    await this.page.current.alternarLoading();

    const dados: IParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));

    const contrato: ContratoDisponivel = JSON.parse(localStorage.getItem("emprestimo-contrato-selecionado"));

    const funcionario = await FuncionarioService.Buscar();

    const aderiuContratoEmpréstimoOnline = funcionario.DadosPessoais.ID_EMP_ONLINE === "S";
    const mostrarCartaoMontreal = await EmprestimoService.BuscarMostrarCartaoMontreal(contrato);

    await this.setState({
      funcionario,
      valorMargemConsignavel: dados.valorMargemConsignavel,
      contrato,
      ativo: ["1"].includes(dados.plano.CD_CATEGORIA),
      cdPlano: dados.plano.CD_PLANO,
      aderiuContratoEmpréstimoOnline,
      mostrarCartaoMontreal
    });

    await this.page.current.alternarLoading();
  };

  contratar = async () => {
    try {
      const dados: ParametrosContrato = {
        Contrato: this.state.contrato,
        ValorMargem: this.state.valorMargemConsignavel,
        Token: this.state.token,
        TokenDigitado: this.state.tokenDigitado,
        NomeArquivoMargemConsignavel: this.state.oidArquivoUpload,
        NomeArquivoCartaoMongeral: this.state.oidArquivoCartaoMongeral,
      };
      // const numContrato = await EmprestimoService.Contratar(dados);
      await EmprestimoService.Contratar(dados);
      alert("Sua solicitação foi enviada com sucesso!");

      this.setState({
        modalAvaliacao: true,
        mostrarModalToken: false,
      });
    } catch (e) {
      const err: any = e;
      alert(err.response ? err.response.data : err);
    }
  };

  handleEnviarAvaliacao = async () => {
    this.setState({
      modalAvaliacao: false,
    });

    this.props.history.push("/emprestimos");
  };

  alternarModalToken = async () => {
    try {
      this.setState({
        mostrarModalToken: !this.state.mostrarModalToken,
      });
    } catch (err) {
      console.log(err);
    }
  };

  enviarToken = async () => {
    if (this.state.enviarPorEmail || this.state.enviarPorSMS) {
      try {
        //await this.setState({ loading: true });
        var token = await EmprestimoService.GerarToken(this.state.enviarPorEmail, this.state.enviarPorSMS);
        await this.setState({
          token,
          tokenEnviado: true,
        });
        await alert(
          "Para validar a operação de empréstimo, insira o código que foi enviado por SMS ao seu celular ou ao seu email e clique em contratar empréstimo."
        );
      } catch (e) {
        const ex: any = e;
        if (ex.response) {
          await alert(ex.response.data);
        } else {
          console.warn("Ocorreu um erro ao processar requisição!");
        }
      } finally {
        //await this.setState({ loading: false });
      }
    } else {
      alert("Favor selecionar pelo menos uma forma de envio do token.");
    }
  };

  abrirModalToken = async () => {
    if (this.state.ativo && !this.state.oidArquivoUpload) {
      await alert("É necessário enviar um Comprovante de Margem Consignável!");
      return;
    }

    if (this.state.cdPlano === DMN_PLANO.PREVIDENCIAL_B && !this.state.oidArquivoCartaoMongeral && this.state.mostrarCartaoMontreal) {
      await alert("É necessário enviar o Cartão Proposta Mongeral preenchido!");
      return;
    }

    this.setState({ mostrarModalToken: true });
  };

  setOidArquivoUpload = async (oid: string) => {
    this.setState({ oidArquivoUpload: oid });
  };

  setOidArquivoCartaoMongeral = async (oid: string) => {
    this.setState({ oidArquivoCartaoMongeral: oid });
  };

  render() {
    return (
      <MasterPage {...this.props} Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONTRATAÇÃO} ref={this.page}>
        {this.state.modalAvaliacao && (
          <Avaliacao numFuncionalidade={NumFuncionalidade.EMPRESTIMOS_CONTRATAÇÃO} cdPlano={this.state.cdPlano} onSend={this.handleEnviarAvaliacao} />
        )}

        {!this.state.aderiuContratoEmpréstimoOnline && (
          <Alerta
            tipo={TipoAlerta.danger}
            mensagem={
              "Você não pode usar esta funcionalidade, pois não aderiu ao contrato de empréstimo on-line. Para aderir, entre em contato com nossa equipe da Seguridade através do e-mail seguridade@previrb.com.br ou pelo telefone 21 2277-1999, de segunda a sexta-feira, das 9h às 17h."
            }
          />
        )}

        {this.state.aderiuContratoEmpréstimoOnline && (
          <>
            <h3>Bem-Vindo ao Simulador de Empréstimos da PREVIRB!</h3>
            <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5>

            {!(this.state.funcionario &&
              this.state.funcionario.Entidade &&
              this.state.funcionario.Entidade.NUM_BANCO &&
              this.state.funcionario.Entidade.NUM_AGENCIA &&
              this.state.funcionario.Entidade.NUM_CONTA) && (
                <>
                  <Alerta tipo={TipoAlerta.danger} mensagem={"Você não possui dados bancários cadastrados, favor enviar um comprovante para seguridade@previrb.com.br, indicando a sua matrícula, ou entrar em contato com nossa equipe de atendimento pelo telefone 21-2277-1999, de segunda a sexta-feira, das 9h às 17h."} />
                </>
              )}

            {(this.state.funcionario &&
              this.state.funcionario.Entidade &&
              this.state.funcionario.Entidade.NUM_BANCO &&
              this.state.funcionario.Entidade.NUM_AGENCIA &&
              this.state.funcionario.Entidade.NUM_CONTA) && (
                <>
                  <Box titulo={"Requerimento do Empréstimo"} renderRow>
                    <Box titulo={"Dados Bancários"}>
                      <CampoEstatico titulo={"Banco"} valor={this.state.funcionario.Entidade.NUM_BANCO} tamanhoTitulo={"md-4"} />

                      <CampoEstatico titulo={"Agência"} valor={this.state.funcionario.Entidade.NUM_AGENCIA} tamanhoTitulo={"md-4"} />

                      <CampoEstatico titulo={"Conta"} valor={this.state.funcionario.Entidade.NUM_CONTA} tamanhoTitulo={"md-4"} />
                    </Box>

                    {this.state.ativo && (
                      <ArquivoUpload
                        texto={
                          'Para concluir a sua solicitação de empréstimo é necessário enviar o seu último contracheque contendo a margem consignável informada por você. Somente será possível enviar arquivos "TIF, JPG, BMP, PNG e PDF".'
                        }
                        titulo={"Comprovante Margem Consignável"}
                        id={"documento"}
                        setOidArquivoUpload={this.setOidArquivoUpload}
                      />
                    )}

                    {this.state.mostrarCartaoMontreal && (
                      <ArquivoUpload
                        texto={
                          <>
                            {"Para concluir sua solicitação é necessário  preencher do Cartão Proposta Mongeral, para isso "}
                            <a className={"btn btn-primary m2"} target={"_blank"} rel={"noopener noreferrer"} href={"./cartao_proposta_mongeral_contrato_51952.pdf"}>
                              {"click aqui"}
                            </a>
                            {" para efetuar o download."}
                            <br />
                            <br />
                            {"Preencha os seguintes campos:"}
                            <br />
                            <br />
                            {
                              "Página 1: Dados do proponente (preencher do campo “nome completo” até “residente no Brasil?” e rubricar ao final da página)."
                            }
                            <br />
                            <br />
                            {"Página 2: Declarações do proponente (datar e assinar)."}
                            <br />
                            <br />
                            {"Páginas 3 e 4: Notas explicativas (rubricar ao final das duas páginas)."}
                            <br />
                            <br />
                            {
                              "Página 5: Declaração pessoal de atividade e saúde (preencher nome completo e CPF – responder SIM ou NÃO, somente na coluna titular, nas 11 perguntas – datar e assinar)"
                            }
                            <br />
                            <br />
                            {'Somente será possível enviar arquivos "TIF, JPG, BMP, PNG e PDF".'}
                          </>
                        }
                        titulo={"Cartão Proposta Mongeral"}
                        id={"cartao"}
                        setOidArquivoUpload={this.setOidArquivoCartaoMongeral}
                      />
                    )}

                    <Botao
                      titulo={"Solicitar empréstimo!"}
                      className={"ml-2"}
                      onClick={this.abrirModalToken}
                      icone={"fas fa-chevron-right"}
                      usaLoading
                      iconeDireita
                      submit
                    />
                  </Box>

                  <Modal
                    titulo={"Token de Confirmação"}
                    tituloBotaoFechar={"Cancelar"}
                    visivel={this.state.mostrarModalToken}
                    onClose={this.alternarModalToken}
                    onConfirm={this.alternarModalToken}
                  >
                    <Form>
                      {!this.state.tokenEnviado && (
                        <>
                          <Alerta
                            tipo={TipoAlerta.info}
                            mensagem={
                              "Para concluir a sua solicitação de empréstimo, enviaremos um token de confirmação para o seu celular e/ou e-mail."
                            }
                          />

                          <div>
                            <input
                              type={"checkbox"}
                              id={"sms"}
                              name={"sms"}
                              checked={this.state.enviarPorSMS}
                              onChange={() => {
                                this.setState({
                                  enviarPorSMS: !this.state.enviarPorSMS,
                                });
                              }}
                            />
                            <label className={"m-2"} htmlFor={"sms"}>
                              <b>Enviar token para celular:</b>
                            </label>
                            <CampoEstatico valor={this.state.funcionario.DadosPessoais.FONE_CELULAR} tamanhoTitulo={"md-4"} />
                          </div>
                          <div>
                            <input
                              type={"checkbox"}
                              id={"email"}
                              name={"email"}
                              checked={this.state.enviarPorEmail}
                              onChange={() => {
                                this.setState({
                                  enviarPorEmail: !this.state.enviarPorEmail,
                                });
                              }}
                            />
                            <label className={"m-2"} htmlFor={"email"}>
                              <b>Enviar token para e-mail:</b>
                            </label>
                            <CampoEstatico valor={this.state.funcionario.DadosPessoais.EMAIL_AUX} />
                          </div>

                          <Botao titulo={"Enviar Token"} onClick={this.enviarToken} usaLoading block submit />
                        </>
                      )}

                      {this.state.tokenEnviado && (
                        <>
                          <CampoTexto
                            contexto={this}
                            tipo={"text"}
                            nome={"tokenDigitado"}
                            valor={this.state.tokenDigitado}
                            posicaoTitulo={PosicaoTituloCampoTexto.cima}
                            titulo={"Token"}
                          />

                          <Botao titulo={"Solicitar Empréstimo"} onClick={this.contratar} block submit usaLoading />
                        </>
                      )}
                    </Form>
                  </Modal>
                </>
              )}
          </>
        )}
      </MasterPage>
    );
  }
}
